import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Paper, Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import useUtilStyles from '../../../../helpers/styles/utils.styles';
import TableHeader from '../../../../models/TableHeader';
import FormWrapperWithTitle from '../../../../components/UI/Wrapper/Form/FormWrapperWithTitle';
import Grid24 from '../../../../components/UI/Grid24';
import TooltipUI from '../../../../components/UI/Tooltip/Tooltip';
import { formatCpfCnpj } from '../../../../helpers/utils/utils';
import useStyles from './DadosSocios.styles';

function DadosSocios({ formFields }) {
  const utilStyles = useUtilStyles();
  const styles = useStyles();

  const [columns] = useState([
    new TableHeader({
      id: 'nome',
      label: 'Nome',
      showTip: true,
      minWidth: 'auto',
      width: 200,
      maxWidth: 200,
    }),
    new TableHeader({
      id: 'cpf', label: 'CPF', minWidth: 'auto', alignCell: 'center',
    }),
  ]);

  const socios = formFields?.socios || [];

  const rows = socios.map(socio => ({
    id: socio.idSocio?.value,
    values: {
      idSocio: socio.idSocio?.value,
      nome: socio.nome?.value,
      cpf: formatCpfCnpj(socio.cpf?.value),
    },
  }));

  const getContent = (value, column) => {
    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom-start" interactive>
          <div className={styles.fitContent}>
            <pre
              className={styles.overFlowText}
              style={{ maxWidth: column.maxWidth - 16 }}
            >
              {column.format && typeof value === 'number' ? column.format(value) : value}
            </pre>
          </div>
        </TooltipUI>
      );
    }
    return (
      <pre>
        {column.format && typeof value === 'number' ? column.format(value) : value}
      </pre>
    );
  };

  const buildTableRow = row => (
    <TableRow key={row.id}>
      {columns.map((column) => {
        const value = row.values[column.id];
        return (
          <TableCell
            key={column.id}
            align={column.alignCell}
          >
            {getContent(value, column)}
          </TableCell>
        );
      })}
    </TableRow>
  );

  return (
    <Grid24 container isFormContainer>
      <FormWrapperWithTitle title="Dados do(s) Sócio(s)">
        <Grid24 container isFormContainer spacing={1} className={utilStyles.mt16}>
          <Grid24 item xs={24} sm={24}>
            <Paper className={styles.wrapper}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {columns.map(column => (
                      <TableCell
                        id={column.id}
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map(row => buildTableRow(row))}
                </TableBody>
              </Table>
            </Paper>
          </Grid24>
        </Grid24>
      </FormWrapperWithTitle>
    </Grid24>
  );
}

export default withRouter(DadosSocios);
